import { useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { IAdditionalSetupData, ISimpleEventDetail } from "interfaces";
import { currencySymbol, getFormattedDateTime } from "utills/helpers";

export const ChangeDistance = ({
  additionalSetupData,
  eventDetailData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="box-container p-4 text-sm sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-8 lg:gap-x-6">
        <div className="sm:col-span-2">
          <Label
            required
            id="change_distance.start_change_distance_date"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.startDate"
            )}
          />
          {getFormattedDateTime(
            additionalSetupData?.start_change_distance_date ?? ""
          )}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_distance.end_change_distance_date"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.endDate"
            )}
          />
          {getFormattedDateTime(
            additionalSetupData?.end_change_distance_date ?? ""
          )}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_distance.max_number_of_times_to_change_distance"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.maxNumberOfTimes"
            )}
          />
          {additionalSetupData?.max_number_of_times_to_change_distance}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_distance.change_distance_fee"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.changeFee"
            )}
          />
          {additionalSetupData?.change_distance_fee}{" "}
          {currencySymbol(eventDetailData?.currency ?? "")}
        </div>
      </div>
    </div>
  );
};
